module.exports = __webpack_public_path__ + "img/trayek-add.5b5bc43b.svg";